import { ValuationFormValues } from "@/types";

export const transformToPayload = (form: ValuationFormValues) => {
  return {
    upi: form.upi ?? "",
    plotNumber: form.plotNumber ?? "",
    ownerIdNumber: form.ownerIdNumber ?? "",
    ownerName: form.ownerName ?? "",

    location: {
      country: form.country ?? "",
      province: form.province ?? "",
      district: form.district ?? "",
      sector: form.sector ?? "",
      cell: form.cell ?? "",
      village: form.village ?? "",
      streetAddress: form.streetAddress ?? "",
      
      // Uganda-specific location fields
      region: form.region ?? "",
      subRegion: form.subRegion ?? "",
      county: form.county ?? "",
      subcounty: form.subcounty ?? "",
      parish: form.parish ?? "",

      coordinates: {
        latitude: form.latitude ?? 0,
        longitude: form.longitude ?? 0,
      },
    },

    landParcel: {
      area: form.landArea ?? 0,
      slopeCategory: form.slopeCategory ?? "",
      landUse: form.landUse ?? "",
      accessToRoad: form.accessToRoad ?? false,
    },

    landValue: form.landValue ?? 0,

    valuationDetails: {
      landRate: form.landRate ?? 0,
      mainHouseRate: form.mainHouseRate ?? 0,
      annexRate: form.annexRate ?? 0,
      fenceRate: form.fenceRate ?? 0,
      retainingWallRate: form.retainingWallRate ?? 0,
      entranceGateRate: form.entranceGateRate ?? 0,
      entranceGateLength: form.entranceGateLength ?? 0,
      pavedAreaRate: form.pavedAreaRate ?? 0,
      landValue: (form.landRate ?? 0) * (form.landArea ?? 0),
      septicTankValue: form.septicTankValue ?? 0,
      septicTankNumber: form.septicTankNumber ?? 0,
      landscapingValue: form.landscapingValue ?? 0,
      annualDepreciationRate: form.annualDepreciationRate ?? 0,
      depreciationRate: form.depreciationRate ?? 0,
      forcedSaleDiscount: form.forcedSaleDiscount ?? 0,
      mainHouseArea: form.mainHouseArea ?? 0,
      annexHouseArea: form.annexHouseArea ?? 0,
      gateFenceLength: form.gateFenceLength ?? 0,
      fenceLength: form.fenceLength ?? 0,
      gardenArea: form.gardenArea ?? 0,
      gardenRate: form.gardenRate ?? 0,
      retainingWallsLength: form.retainingWallsLength ?? 0,
      pavedArea: form.pavedArea ?? 0,
      verandahArea: form.verandahArea ?? 0,
      verandahRate: form.verandahRate ?? 0,
    },
    
    hasAnnexBuilding: form.hasAnnexBuilding ?? false,
    hasWater: form.hasWater ?? false,
    hasElectricity: form.hasElectricity ?? false,
    hasOutsideKitchen: form.hasOutsideKitchen ?? false,
    hasGarden: form.hasGarden ?? false,
    hasPavedParking: form.hasPavedParking ?? false,

    outsideKitchenDescription: form.outsideKitchenDescription ?? "",
    waterTankDescription: form.waterTankDescription ?? "",
    landscapingDescription: form.landscapingDescription ?? "",
    soilDrainageDescription: form.soilDrainageDescription ?? "",
    pvcPipesDescription: form.pvcPipesDescription ?? "",
    washTapsDescription: form.washTapsDescription ?? "",
    fixturesFittingsDescription: form.fixturesFittingsDescription ?? "",

    roofCondition: form.roofCondition ?? "Excellent",
    wallsCondition: form.wallsCondition ?? "Excellent",
    windowsCondition: form.windowsCondition ?? "Excellent",
    doorsCondition: form.doorsCondition ?? "Excellent",
    floorCondition: form.floorCondition ?? "Excellent",

    bedrooms: form.bedrooms ?? 0,
    bathrooms: form.bathrooms ?? 0,

    yearOfConstruction: form.yearOfConstruction,
    effectiveAge: form.effectiveAge ?? 0,
    unitPrice: form.unitPrice ?? 0,
    constructedArea: form.constructedArea ?? 0,
    originalCostOfConstruction: form.originalCostOfConstruction ?? 0,
    maintenanceCoefficient: form.maintenanceCoefficient ?? 0,
    depreciatedValue: form.depreciatedValue ?? 0,
    presentValue: form.presentValue ?? 0,
    roofType: form.roofType ?? "Iron Sheets",

    // FILES
    cityMasterPlan: form.cityMasterPlan ?? null,
    photo: form.photo ?? null,

    propertyDetails: {
      area: form.area ?? 0,
      age: form.age ?? 0,
      condition: form.condition ?? "",
      zoning: form.zoning ?? "",
    },

    frontView: form.frontView ?? null,
    backView: form.backView ?? null,
    leftView: form.leftView ?? null,
    rightView: form.rightView ?? null,

    livingRoom: form.livingRoom ?? null,
    kitchen: form.kitchen ?? null,
    bedroom: form.bedroom ?? null,
    bathroom: form.bathroom ?? null,
    diningRoom: form.diningRoom ?? null,
    veranda: form.veranda ?? null,

    googleEarthOne: form.googleEarthOne ?? null,
    googleEarthTwo: form.googleEarthTwo ?? null,
    masterPlan: form.masterPlan ?? null,
  };
};